import React from "react";

function PortfolioManagementServices() {
  return (
    <main>
      {/* Breadcrumb Section */}
      <section className="page_breadcrumb">
        <div className="container">
          <div className="breadcrumb_content centred">
            <h1 className="breadcrumb_title">Portfolio Management Services</h1>
            <ul className="breadcrumb_menu">
              <li>
                <a href="/">Home</a>
              </li>
              <li>/</li>
              <li>Portfolio Management Services</li>
            </ul>
          </div>
        </div>
      </section>

      {/* About Services */}
      <section className="feature_section home_five" data-aos="fade-up">
        <div className="container">
          <div className="row">
            <div className="section_title centred">
              <h2>Portfolio Management Services (PMS)</h2>
              <p>
                Elite portfolio management via MT4 & MT5 for high-net-worth
                investors seeking institutional-grade returns for Indian and
                global markets.
              </p>
            </div>
            <div className="col-xl-12 col-lg-12 col-md-12">
              <div
                className="range-box-service"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                <div className="row align-items-center">
                  <div className="col-xl-8 col-lg-8 col-md-12">
                    <h3>Premium Investment Plan</h3>
                    <p>50 Lacs and Multiple</p>
                  </div>
                  <div className="col-xl-4 col-lg-4 col-md-12">
                    <div className="plan-range-box">
                      <div className="plan-range">
                        <h5>₹50L+</h5>
                        <h6>Minimum INR</h6>
                      </div>
                      <div className="plan-range">
                        <h5>$100K+</h5>
                        <h6>Minimum USD</h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Market Coverage*/}
      <section className="pricing_section pt-0 pb-0">
        <div className="container">
          <div className="row">
            <div className="col-lg-5 col-md-6 col-sm-12 pricing_block">
              <div
                className="pricing_block_one aos-init aos-animate text-left"
                data-aos="fade-up"
                data-aos-easing="linear"
                data-aos-duration={500}
              >
                <div className="pricing_table" style={{ textAlign: "left" }}>
                  <div className="table_header">
                    <h5>Market Coverage</h5>
                  </div>
                  <div className="table_content ">
                    <ul className="feature_list text-left">
                      <li className="Coverage-list-2">
                        <i className="fa-solid fa-check" />
                        <span>NSE</span> - National Stock Exchange
                      </li>
                      <li className="Coverage-list-2">
                        <i className="fa-solid fa-check" />
                        <span>BSE </span> - Bombay Stock Exchange
                      </li>
                      <li className="Coverage-list-2">
                        <i className="fa-solid fa-check" />
                        <span>MCX </span> - Multi Commodity Exchange
                      </li>
                      <li className="Coverage-list-2">
                        <i className="fa-solid fa-check" />
                        <span>NCDEX </span> - National Commodity Exchange
                      </li>
                      <li className="Coverage-list-2">
                        <i className="fa-solid fa-check" />
                        <span>Commodities</span>
                      </li>
                      <li className="Coverage-list-2">
                        <i className="fa-solid fa-check" />
                        <span>Indices</span>
                      </li>
                      <li className="Coverage-list-2">
                        <i className="fa-solid fa-check" />
                        <span>Forex &amp; CryptoCurrency</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-7 col-md-6 col-sm-12 pricing_block">
              <div
                className="pricing_block_one aos-init aos-animate text-left"
                data-aos="fade-up"
                data-aos-easing="linear"
                data-aos-duration={500}
              >
                <div className="pricing_table" style={{ textAlign: "left" }}>
                  <div className="table_header">
                    <h5>Trading Strategy</h5>
                  </div>
                  <div className="table_content ">
                    <ul className="feature_list text-left">
                      <li className="Coverage-list-2">
                        <i className="fa-solid fa-check" />
                        <span>Total Trades: 3-300</span> - Flexible execution
                        based on market dynamics
                      </li>
                      <li className="Coverage-list-2">
                        <i className="fa-solid fa-check" />
                        <span>RSI, CDMA, Pivot Strategy</span> - Multi-indicator
                        technical analysis
                      </li>
                      <li className="Coverage-list-2">
                        <i className="fa-solid fa-check" />
                        <span>Averaging &amp; Hedging </span> - Advanced risk
                        mitigation
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/*Profit & Loss Section */}
      <section
        className="service_section mt-5 pt-5 pb-5 aos-init aos-animate"
        data-aos="fade-up"
        data-aos-easing="linear"
        data-aos-duration={400}
      >
        <div className="circle_one" />
        <div className="circle_two" />
        <div className="container">
          <div className="row">
            <div className="col-xl-6 col-md-6 col-sm-12">
              <div
                className="service_block_one aos-init aos-animate"
                data-aos="fade-up"
                data-aos-easing="linear"
                data-aos-duration={500}
              >
                <h4 className="text-white text-left">Profit Distribution</h4>
                <div className="profit-range-box">
                  <div className="profit-plan-range">
                    <h5>65%</h5>
                    <h6>Investor</h6>
                  </div>
                  <div className="profit-plan-range">
                    <h5>35%</h5>
                    <h6>Fund Manager</h6>
                  </div>
                </div>
                <div className="profit-plan-range p-2">
                  <p className="mb-0">
                    Balanced profit &amp; loss sharing model
                  </p>
                </div>
              </div>
            </div>
            <div className="col-xl-6 col-md-6 col-sm-12">
              <div
                className="service_block_one aos-init aos-animate"
                data-aos="fade-up"
                data-aos-easing="linear"
                data-aos-duration={500}
              >
                <h4 className="text-white text-left">Expected Returns</h4>
                <div className="profit-plan-range">
                  <h5>30–500%</h5>
                  <h6>Annual Profit Potential</h6>
                  <p className="mb-0">
                    Based on premium algorithmic strategies
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Key Terms & Conditionsr */}
      <section
        className="why_choose_us pt_150 about_page aos-init aos-animate"
        data-aos="fade-up"
        data-aos-easing="linear"
        data-aos-duration={500}
      >
        <div className="container">
          <div className="border_top" />
          <div className="section_title centred">
            <h2>Withdrawal Policy &amp; Terms</h2>
          </div>
          <div className="row">
            <div className="col-xl-4 col-md-6 col-sm-12">
              <div
                className="why_choose_block_two mb_40 aos-init aos-animate"
                data-aos="fade-right"
                data-aos-easing="linear"
                data-aos-duration={500}
              >
                <div className="choose_icon">
                  <i class="fa-solid fa-money-bill-transfer"></i>
                </div>
                <h4>Withdrawal</h4>
                <p>
                  On every
                  <span
                    style={{ fontWeight: 600, fontSize: 18, color: "#000" }}
                  >
                    10% increase
                  </span>{" "}
                  in equity/profit
                </p>
                <span
                  style={{
                    borderTop: "1px solid #ddd",
                    paddingTop: 5,
                    fontSize: 14,
                  }}
                >
                  Available daily or monthly
                </span>
              </div>
            </div>
            <div className="col-xl-4 col-md-6 col-sm-12">
              <div
                className="why_choose_block_two mb_40 aos-init aos-animate"
                data-aos="fade-right"
                data-aos-easing="linear"
                data-aos-duration={500}
              >
                <div className="choose_icon">
                  <i class="fa-solid fa-hands-bound"></i>
                </div>
                <h4>Fund Control</h4>
                <p>
                  Funds in
                  <span
                    style={{ fontWeight: 600, fontSize: 18, color: "#000" }}
                  >
                    your trading account
                  </span>
                </p>
                <span
                  style={{
                    borderTop: "1px solid #ddd",
                    paddingTop: 5,
                    fontSize: 14,
                  }}
                >
                  Under investor control
                </span>
              </div>
            </div>
            <div className="col-xl-4 col-md-6 col-sm-12">
              <div
                className="why_choose_block_two mb_40 aos-init aos-animate"
                data-aos="fade-right"
                data-aos-easing="linear"
                data-aos-duration={500}
              >
                <div className="choose_icon">
                  <i class="fa-solid fa-user-clock"></i>
                </div>
                <h4>Lock-in Period</h4>
                <p>
                  <span
                    style={{ fontWeight: 600, fontSize: 18, color: "#000" }}
                  >
                    3 Years{" "}
                  </span>
                  commitment
                </p>
                <span
                  style={{
                    borderTop: "1px solid #ddd",
                    paddingTop: 5,
                    fontSize: 14,
                  }}
                >
                  Terms &amp; conditions apply
                </span>
              </div>
            </div>
            <div className="col-xl-12 col-lg-12 col-md-12">
              <div
                className="range-box-service p-5 aos-init aos-animate text-center"
                data-aos="fade-up"
                data-aos-easing="linear"
                data-aos-duration={500}
              >
                <h3>Complete Service Details</h3>
                <p>
                  Download the full documentation for comprehensive information
                </p>
                <div className="link-btn mt-3">
                  <a
                    href="/pdf/PMS.pdf"
                    className="btn_style_one"
                    target="_blank"
                  >
                    Open Pdf Document
                  </a>
                </div>
              </div>
            </div>
            <p>
              <span className="text-danger" style={{ fontWeight: 600 }}>
                Risk Disclosure -
              </span>
              *Investment in securities market is subject to market risks. Past
              performance is not indicative of future returns. The profit
              projections are based on historical data and algorithmic
              performance. Both parties share profit and loss in the ratio of
              65:35 (Investor:Fund Manager). Expected Returns is not guaranteed.
              Please read all terms carefully before investing.
            </p>
          </div>
        </div>
      </section>
    </main>
  );
}

export default PortfolioManagementServices;
